// import './styles.scss';

const CardClicklabe = ({ children, ...props }) => {
  return (
    <div className="card__clickable" {...props}>
      {children}
    </div>
  );
};

export default CardClicklabe;
